/* tslint:disable */
/* eslint-disable */
/**
 * Project Freelancer API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FetchQuoteContextRequest
 */
export interface FetchQuoteContextRequest {
    /**
     * 
     * @type {string}
     * @memberof FetchQuoteContextRequest
     */
    clientIdentityId: string;
    /**
     * 
     * @type {string}
     * @memberof FetchQuoteContextRequest
     */
    freelancerQuoteId?: string;
    /**
     * 
     * @type {string}
     * @memberof FetchQuoteContextRequest
     */
    projectConversationId?: string;
    /**
     * 
     * @type {string}
     * @memberof FetchQuoteContextRequest
     */
    projectRenewalId?: string;
}

/**
 * Check if a given object implements the FetchQuoteContextRequest interface.
 */
export function instanceOfFetchQuoteContextRequest(value: object): value is FetchQuoteContextRequest {
    if (!('clientIdentityId' in value) || value['clientIdentityId'] === undefined) return false;
    return true;
}

export function FetchQuoteContextRequestFromJSON(json: any): FetchQuoteContextRequest {
    return FetchQuoteContextRequestFromJSONTyped(json, false);
}

export function FetchQuoteContextRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): FetchQuoteContextRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'clientIdentityId': json['clientIdentityId'],
        'freelancerQuoteId': json['freelancerQuoteId'] == null ? undefined : json['freelancerQuoteId'],
        'projectConversationId': json['projectConversationId'] == null ? undefined : json['projectConversationId'],
        'projectRenewalId': json['projectRenewalId'] == null ? undefined : json['projectRenewalId'],
    };
}

export function FetchQuoteContextRequestToJSON(value?: FetchQuoteContextRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'clientIdentityId': value['clientIdentityId'],
        'freelancerQuoteId': value['freelancerQuoteId'],
        'projectConversationId': value['projectConversationId'],
        'projectRenewalId': value['projectRenewalId'],
    };
}

